import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';
import { take, switchMap, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: 'aa-chips-tag-item-value',
    templateUrl: './chips-tag-item-value.component.html',
    styleUrls: [
        './chips-tag-item-value.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipsTagItemValueComponent
{
    @Input() fullTagName: string;
    @Input() bgColor: string;
    @Input() fgColor: string;
    public qsWord: Observable<string> = of('');

    constructor (
        routerStore: Store<any>,
        store: Store<IAuroraState>
    )
    {
        this.qsWord = routerStore
            .pipe(
                take(1),
                select(fromRootStore.getRouteInfos),
                map((obj: any): string =>
                    obj.url
                ),
                switchMap((url: string): Observable<string> =>
                    store.select(fromRootStore.getQuickSearchValue, { key: url })
                )
            );
    }
}
